import './Main.css';
import React from "react";
import { useMediaQuery } from 'react-responsive'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { useNavigate, useLocation  } from 'react-router-dom';

import { Helmet } from 'react-helmet';

import { Button } from 'primereact/button';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { TabMenu } from 'primereact/tabmenu';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Dropdown } from 'primereact/dropdown';

import DOMPurify from 'dompurify';

import jwtDecode from 'jwt-decode';

// Load Actions
import * as AppActions from '../../Store/Actions/App'

// Load Componentes
import HeaderView from '../../Components/Layout/Header';
import {
    handleClickScroll
} from '../../Components/Utils';

const dropdownOptions = [
  { label: 'Política de Privacidade', value: 0 },
  { label: 'Termos de Uso', value: 1 },
  { label: 'Preferências de Cookies', value: 2 }
];

const UseTermsMain = (props) => {
  const { retrieveTermsContent } = props;
  const navigate = useNavigate();

  const isDesktopOrLaptop = useMediaQuery({ query: '(min-width: 1024px)' });
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1023px)' });
  const isMobile = useMediaQuery({ query: '(max-width: 767px)' });

  const [loading, setLoading] = React.useState(true);
  const [activeIndex, setActiveIndex] = React.useState(0);
  const [contentHtml, setContentHtml] = React.useState('<p>Carregando...</p>');
  const [title, setTitle] = React.useState('Política de Privacidade');

  const [menuTop, setMenuTop] = React.useState(272); // valor inicial fixo após o header
  const menuRef = React.useRef(null);

  const tabItems = [
    { label: 'Política de Privacidade'},
    { label: 'Termos de Uso'},
    { label: 'Preferências de Cookies' }
  ];

  const handleTabChange = async (e) => {
    setActiveIndex(e.index);
    setLoading(true);

    let url = '';
    let selectedTitle = '';

    switch (e.index) {
      case 0:
        url = 'https://backendcms.estacaodoolho.com.br/wp-json/wp/v2/pages/3';
        selectedTitle = 'Política de Privacidade';
        break;
      case 1:
        url = 'https://backendcms.estacaodoolho.com.br/wp-json/wp/v2/pages/550';
        selectedTitle = 'Termos de Uso';
        break;
      case 2:
        url = 'https://backendcms.estacaodoolho.com.br/wp-json/wp/v2/pages/552';
        selectedTitle = 'Preferências de Cookies';
        break;
      default:
        setContentHtml('<p>Conteúdo não disponível.</p>');
        return;
    }

    setTitle(selectedTitle);

    try {
      const res = await fetch(url);
      const json = await res.json();
      setContentHtml(json.content.rendered);
    } catch (error) {
      console.error('Erro ao carregar conteúdo:', error);
      setContentHtml('<p>Conteúdo não disponível. Tente novamente mais tarde.</p>');
    } finally {
      setLoading(false);
    }

    // Scroll to top after tab change
    window.scrollTo({ top: 0, behavior: 'smooth' });

  };

  const location = useLocation();

  const getIndexFromPath = (pathname) => {
    if (pathname.includes('/uso')) return 1;
    if (pathname.includes('/cookie')) return 2;
    return 0; // default = privacidade
  };


  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });

    const index = getIndexFromPath(location.pathname);
    handleTabChange({ index });
  }, [location.pathname]);

 
  React.useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const newTop = Math.max(100, 272 - scrollY); // Evita colar no topo
      setMenuTop(newTop < 20 ? 20 : newTop); // nunca menor que 20px
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);



  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content="Termos de uso, Política de Privacidade e Preferências de Cookies" />
        <meta name="keywords" content="termos de uso, política de privacidade, preferências de cookies" />
        <meta name="robots" content="index, follow" />
      </Helmet>

      <div id="termsMainSection" className={isMobile ? "wrapper_terms__content mobileWrapper" : "wrapper_terms__content"}>

        <HeaderView />

        <div className={isMobile ? "mobileWrapperBox wrapper_terms__content_container" : "wrapper_terms__content_container"}>
          
          <div className="wrapper_terms__content_container_highlight" style={{ marginTop: "3rem", alignItems: "flex-start" }}>
            <div className="wrapper_terms__content_container_highlight_title">
              {title}
            </div>
          </div>

          <div className={isMobile ? "wrapper_terms__inner_content_container_block mobileTermsWrapperInner" : "wrapper_terms__inner_content_container_block"} style={{ marginTop: isMobile ? "0" : "2rem" }}>

            {/* <!-- Menu --> */}
            <div className="wrapper_terms__content_container_block " style={{flex:1.1,minHeight: isMobile ? "auto" : "50vh",marginTop:"3.25rem"}}>
              {/* Menu Desktop/Tablet: TabMenu */}
              {!isMobile && (
                <div
                  ref={menuRef}
                  className="wrapper_terms__content_container_tabs"
                  style={{
                    position: 'fixed',
                    top: `${menuTop}px`,
                    width: '16rem',
                    zIndex: 1000,
                  }}
                >
                  <TabMenu
                    model={tabItems}
                    activeIndex={activeIndex}
                    onTabChange={handleTabChange}
                    className="vertical-tabmenu"
                  />
                </div>
              )}

              {/* Menu Mobile: Dropdown */}
              {isMobile && (
                <div style={{ width: '100%', marginBottom: '2rem' }}>
                  <Dropdown
                    value={activeIndex}
                    options={dropdownOptions}
                    onChange={(e) => handleTabChange({ index: e.value })}
                    placeholder="Selecione uma opção"
                    style={{ width: '100%' }}
                    className="termsDropdownSelector"
                  />
                </div>
              )}
            </div>

            {/* <!-- Content --> */}
            <div className="wrapper_terms__content_container_block flex-3 contentBlock" style={{flex:3}}>
              <div className="wrapper_terms__content_container_text" style={{ minHeight: isMobile ? "auto" : "50vh", marginBottom: "9rem" }}>
                {loading ? (
                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '20vh' }}>
                    <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="4" />
                  </div>
                ) : (
                  <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(contentHtml) }} />
                )}
              </div>
            </div>

          </div>
        </div>
      </div>
    </>
  );
}

const mapStateToProps = store => ({
  dialog: store.appReducer.dialog
});

const mapDispatchToProps = dispatch => bindActionCreators({ ...AppActions }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UseTermsMain);
